module.exports = __webpack_public_path__ + "img/Drivers_Availability_of_Water_Efficiency_Technology.0e40d077.jpg";